// @generated by web/tools/codegen — DO NOT EDIT
//
// Source: web/manifests/metrics.yaml
// Run:    node tools/codegen/main.mjs metrics

import { type MetricLabels, reportMetric } from './reporter';

/** Closed `page` vocabulary of `web_lcp_ms`. */
export type WebLcpMsPage = '/' | '/about' | '/account' | '/blog' | '/contact' | '/conversations' | '/districts' | '/estates' | '/feedback' | '/forms' | '/help' | '/listings' | '/market' | '/partners' | '/privacy' | '/profile' | '/saved' | '/services' | '/terms' | '/tools' | '/transactions' | 'other';

/** Closed `page` vocabulary of `web_cls`. */
export type WebClsPage = '/' | '/about' | '/account' | '/blog' | '/contact' | '/conversations' | '/districts' | '/estates' | '/feedback' | '/forms' | '/help' | '/listings' | '/market' | '/partners' | '/privacy' | '/profile' | '/saved' | '/services' | '/terms' | '/tools' | '/transactions' | 'other';

/** Closed `page` vocabulary of `web_inp_ms`. */
export type WebInpMsPage = '/' | '/about' | '/account' | '/blog' | '/contact' | '/conversations' | '/districts' | '/estates' | '/feedback' | '/forms' | '/help' | '/listings' | '/market' | '/partners' | '/privacy' | '/profile' | '/saved' | '/services' | '/terms' | '/tools' | '/transactions' | 'other';

/** Closed `page` vocabulary of `web_ttfb_ms`. */
export type WebTtfbMsPage = '/' | '/about' | '/account' | '/blog' | '/contact' | '/conversations' | '/districts' | '/estates' | '/feedback' | '/forms' | '/help' | '/listings' | '/market' | '/partners' | '/privacy' | '/profile' | '/saved' | '/services' | '/terms' | '/tools' | '/transactions' | 'other';

/** Closed `page` vocabulary of `web_hydration_ms`. */
export type WebHydrationMsPage = '/' | '/about' | '/account' | '/blog' | '/contact' | '/conversations' | '/districts' | '/estates' | '/feedback' | '/forms' | '/help' | '/listings' | '/market' | '/partners' | '/privacy' | '/profile' | '/saved' | '/services' | '/terms' | '/tools' | '/transactions' | 'other';

/** Closed `component` vocabulary of `web_browser_errors`. */
export type WebBrowserErrorsComponent = 'AppErrorBoundary' | 'auth' | 'conversations' | 'ErrorBoundary' | 'FeatureErrorBoundary' | 'GoogleMaps' | 'GoogleSignIn' | 'hydration' | 'intl' | 'MediaStepForm' | 'realtime' | 'window' | 'other';

/** Closed `level` vocabulary of `web_browser_errors`. */
export type WebBrowserErrorsLevel = 'error' | 'warn';

/** Closed `effective_directive` vocabulary of `web_csp_violations`. */
export type WebCspViolationsEffectiveDirective = 'default-src' | 'script-src' | 'style-src' | 'img-src' | 'font-src' | 'connect-src' | 'frame-src' | 'media-src' | 'object-src' | 'base-uri' | 'form-action' | 'frame-ancestors' | 'other';

/** Closed `reason` vocabulary of `web_maps_degraded`. */
export type WebMapsDegradedReason = 'auth_failure' | 'script_load_error' | 'dev_watermark';

/** Closed `locale` vocabulary of `web_maps_degraded`. */
export type WebMapsDegradedLocale = 'en' | 'zh-HK' | 'zh-CN';

/** Closed `browser_family` vocabulary of `web_maps_degraded`. */
export type WebMapsDegradedBrowserFamily = 'chrome' | 'edge' | 'opera' | 'samsung_internet' | 'android_webview' | 'wechat' | 'headless_chrome' | 'safari' | 'firefox' | 'other';

/** Closed `is_crawler` vocabulary of `web_maps_degraded`. */
export type WebMapsDegradedIsCrawler = 'false' | 'true';

/** Closed `locale` vocabulary of `web_maps_script_loads`. */
export type WebMapsScriptLoadsLocale = 'en' | 'zh-HK' | 'zh-CN';

/** Closed `browser_family` vocabulary of `web_maps_script_loads`. */
export type WebMapsScriptLoadsBrowserFamily = 'chrome' | 'edge' | 'opera' | 'samsung_internet' | 'android_webview' | 'wechat' | 'headless_chrome' | 'safari' | 'firefox' | 'other';

/** Closed `is_crawler` vocabulary of `web_maps_script_loads`. */
export type WebMapsScriptLoadsIsCrawler = 'false' | 'true';

/** Largest Contentful Paint — time to render the largest visible element. */
export interface WebLcpMsLabels extends MetricLabels {
  /** Top-level route SECTION (closed vocab, round-5 K4). The browser normalises `location.pathname` to its first segment (`/estates/{slug}` → `/estates`), else `other`, so slug/detail routes cannot inflate Prometheus cardinality. The generated `Web*Page` union makes a raw pathname a tsc error. */
  page: WebLcpMsPage;
}

export function reportWebLcpMs(value: number, labels: WebLcpMsLabels) {
  reportMetric('web_lcp_ms', value, labels);
}

/** Cumulative Layout Shift — visual stability score. */
export interface WebClsLabels extends MetricLabels {
  /** Top-level route SECTION (closed vocab, round-5 K4). The browser normalises `location.pathname` to its first segment (`/estates/{slug}` → `/estates`), else `other`, so slug/detail routes cannot inflate Prometheus cardinality. The generated `Web*Page` union makes a raw pathname a tsc error. */
  page: WebClsPage;
}

export function reportWebCls(value: number, labels: WebClsLabels) {
  reportMetric('web_cls', value, labels);
}

/** Interaction to Next Paint — responsiveness to user interactions. */
export interface WebInpMsLabels extends MetricLabels {
  /** Top-level route SECTION (closed vocab, round-5 K4). The browser normalises `location.pathname` to its first segment (`/estates/{slug}` → `/estates`), else `other`, so slug/detail routes cannot inflate Prometheus cardinality. The generated `Web*Page` union makes a raw pathname a tsc error. */
  page: WebInpMsPage;
}

export function reportWebInpMs(value: number, labels: WebInpMsLabels) {
  reportMetric('web_inp_ms', value, labels);
}

/** Time to First Byte — initial server response time. */
export interface WebTtfbMsLabels extends MetricLabels {
  /** Top-level route SECTION (closed vocab, round-5 K4). The browser normalises `location.pathname` to its first segment (`/estates/{slug}` → `/estates`), else `other`, so slug/detail routes cannot inflate Prometheus cardinality. The generated `Web*Page` union makes a raw pathname a tsc error. */
  page: WebTtfbMsPage;
}

export function reportWebTtfbMs(value: number, labels: WebTtfbMsLabels) {
  reportMetric('web_ttfb_ms', value, labels);
}

/** Time from initial HTML to full React hydration. */
export interface WebHydrationMsLabels extends MetricLabels {
  /** Top-level route SECTION (closed vocab, round-5 K4). The browser normalises `location.pathname` to its first segment (`/estates/{slug}` → `/estates`), else `other`, so slug/detail routes cannot inflate Prometheus cardinality. The generated `Web*Page` union makes a raw pathname a tsc error. */
  page: WebHydrationMsPage;
}

export function reportWebHydrationMs(value: number, labels: WebHydrationMsLabels) {
  reportMetric('web_hydration_ms', value, labels);
}

/** Client-side error/warn logs by originating component and level. */
export interface WebBrowserErrorsLabels extends MetricLabels {
  /** Originating UI component/subsystem (closed vocabulary; `other` is the BFF catch-all). */
  component: WebBrowserErrorsComponent;
  /** Log level that produced the error series. */
  level: WebBrowserErrorsLevel;
}

export function reportWebBrowserErrors(value: number, labels: WebBrowserErrorsLabels) {
  reportMetric('web_browser_errors', value, labels);
}

/** Content-Security-Policy violations by the violated directive. */
export interface WebCspViolationsLabels extends MetricLabels {
  /** The CSP fetch/document directive that was violated (closed; `other` is the BFF catch-all for a browser-reported directive the app does not emit). */
  effective_directive: WebCspViolationsEffectiveDirective;
}

export function reportWebCspViolations(value: number, labels: WebCspViolationsLabels) {
  reportMetric('web_csp_violations', value, labels);
}

/** Google Maps entered a degraded/failed state in the browser. Emitted once per reason per page load by shared/lib/maps-health.ts. A non-zero rate in prod is the signal the app previously lacked entirely (the "for development purposes only" watermark rendered silently). For `script_load_error` the RATE is the audience (visitors who cannot reach Google), not a fault: read it against `web_maps_script_loads` (#7696). */
export interface WebMapsDegradedLabels extends MetricLabels {
  /** The detectable Maps failure mode (closed vocabulary; no catch-all). */
  reason: WebMapsDegradedReason;
  /** The page locale (closed; `web_locale`). */
  locale: WebMapsDegradedLocale;
  /** The reporting browser family, derived client-side from UA-CH / UA (closed; `web_browser_family`). */
  browser_family: WebMapsDegradedBrowserFamily;
  /** Whether the UA names a crawler in the `@letsgethome/lib/bots` roster (`true` | `false`). */
  is_crawler: WebMapsDegradedIsCrawler;
}

export function reportWebMapsDegraded(value: number, labels: WebMapsDegradedLabels) {
  reportMetric('web_maps_degraded', value, labels);
}

/** A page load began loading the Google Maps JS SDK (a MapBoundary went live). Emitted once per page load by shared/lib/maps-health.ts; the denominator of the script-load failure ratio. */
export interface WebMapsScriptLoadsLabels extends MetricLabels {
  /** The page locale (closed; `web_locale`). */
  locale: WebMapsScriptLoadsLocale;
  /** The browser family (closed; `web_browser_family`). */
  browser_family: WebMapsScriptLoadsBrowserFamily;
  /** Whether the UA names a roster crawler (`true` | `false`). */
  is_crawler: WebMapsScriptLoadsIsCrawler;
}

export function reportWebMapsScriptLoads(value: number, labels: WebMapsScriptLoadsLabels) {
  reportMetric('web_maps_script_loads', value, labels);
}

/** Instrument kind the BFF creates for a web metric. */
export type WebMetricInstrumentType = 'counter' | 'gauge' | 'duration';

export interface WebMetricSpec {
  readonly type: WebMetricInstrumentType;
  readonly labelKeys: readonly string[];
  /** Closed value vocabularies by label key. A label absent here is open
   * (unbounded); a value outside a listed vocabulary is dropped by the BFF. */
  readonly labelValues: Readonly<Record<string, readonly string[]>>;
}

/** Every metric name the browser may report. */
export type WebMetricName = 'web_lcp_ms' | 'web_cls' | 'web_inp_ms' | 'web_ttfb_ms' | 'web_hydration_ms' | 'web_browser_errors' | 'web_csp_violations' | 'web_maps_degraded' | 'web_maps_script_loads';

/** The metric SSoT, projected for the BFF aggregator (allow-list + instrument kind + labels + closed vocabularies). */
export const WEB_METRIC_CATALOG: Record<WebMetricName, WebMetricSpec> = {
  web_lcp_ms: { type: 'duration', labelKeys: ['page'], labelValues: { page: ['/', '/about', '/account', '/blog', '/contact', '/conversations', '/districts', '/estates', '/feedback', '/forms', '/help', '/listings', '/market', '/partners', '/privacy', '/profile', '/saved', '/services', '/terms', '/tools', '/transactions', 'other'] } },
  web_cls: { type: 'gauge', labelKeys: ['page'], labelValues: { page: ['/', '/about', '/account', '/blog', '/contact', '/conversations', '/districts', '/estates', '/feedback', '/forms', '/help', '/listings', '/market', '/partners', '/privacy', '/profile', '/saved', '/services', '/terms', '/tools', '/transactions', 'other'] } },
  web_inp_ms: { type: 'duration', labelKeys: ['page'], labelValues: { page: ['/', '/about', '/account', '/blog', '/contact', '/conversations', '/districts', '/estates', '/feedback', '/forms', '/help', '/listings', '/market', '/partners', '/privacy', '/profile', '/saved', '/services', '/terms', '/tools', '/transactions', 'other'] } },
  web_ttfb_ms: { type: 'duration', labelKeys: ['page'], labelValues: { page: ['/', '/about', '/account', '/blog', '/contact', '/conversations', '/districts', '/estates', '/feedback', '/forms', '/help', '/listings', '/market', '/partners', '/privacy', '/profile', '/saved', '/services', '/terms', '/tools', '/transactions', 'other'] } },
  web_hydration_ms: { type: 'duration', labelKeys: ['page'], labelValues: { page: ['/', '/about', '/account', '/blog', '/contact', '/conversations', '/districts', '/estates', '/feedback', '/forms', '/help', '/listings', '/market', '/partners', '/privacy', '/profile', '/saved', '/services', '/terms', '/tools', '/transactions', 'other'] } },
  web_browser_errors: { type: 'counter', labelKeys: ['component', 'level'], labelValues: { component: ['AppErrorBoundary', 'auth', 'conversations', 'ErrorBoundary', 'FeatureErrorBoundary', 'GoogleMaps', 'GoogleSignIn', 'hydration', 'intl', 'MediaStepForm', 'realtime', 'window', 'other'], level: ['error', 'warn'] } },
  web_csp_violations: { type: 'counter', labelKeys: ['effective_directive'], labelValues: { effective_directive: ['default-src', 'script-src', 'style-src', 'img-src', 'font-src', 'connect-src', 'frame-src', 'media-src', 'object-src', 'base-uri', 'form-action', 'frame-ancestors', 'other'] } },
  web_maps_degraded: { type: 'counter', labelKeys: ['reason', 'locale', 'browser_family', 'is_crawler'], labelValues: { reason: ['auth_failure', 'script_load_error', 'dev_watermark'], locale: ['en', 'zh-HK', 'zh-CN'], browser_family: ['chrome', 'edge', 'opera', 'samsung_internet', 'android_webview', 'wechat', 'headless_chrome', 'safari', 'firefox', 'other'], is_crawler: ['false', 'true'] } },
  web_maps_script_loads: { type: 'counter', labelKeys: ['locale', 'browser_family', 'is_crawler'], labelValues: { locale: ['en', 'zh-HK', 'zh-CN'], browser_family: ['chrome', 'edge', 'opera', 'samsung_internet', 'android_webview', 'wechat', 'headless_chrome', 'safari', 'firefox', 'other'], is_crawler: ['false', 'true'] } },
};
